/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SearchFiltersSchemaJtFilterType = typeof SearchFiltersSchemaJtFilterType[keyof typeof SearchFiltersSchemaJtFilterType];


export const SearchFiltersSchemaJtFilterType = {
  c: 'c',
  p: 'p',
  cp: 'cp',
} as const;
